/**
 * Einen Benutzer direkt in der Zeile wählen, etwa den Verantwortlichen: Ein Klick auf die
 * Anzeige öffnet die Auswahl. Ohne Benutzerliste – sie konnte nicht geladen werden – bleibt die
 * Anzeige unveränderlich. Wie der Name aussieht, gibt der Aufrufer als `children` vor.
 */
import React, { useState } from "react";
import { ListSubheader, Menu, MenuItem, Typography } from "@mui/material";
import InlineEditable, { InlineEditableProps } from "./InlineEditable";

export interface InlineUserOption {
  /** IAM-ID – der Wert, den die Server-Endpunkte erwarten */
  id: string;
  name: string;
}

interface InlineUserPickerProps extends InlineEditableProps {
  /** Der gewählte Benutzer, in der Auswahl markiert */
  value?: string | null;
  users: InlineUserOption[];
  /** Nur bei einem anderen Benutzer als bisher */
  onChange: (userId: string) => void;
}

const InlineUserPicker: React.FC<InlineUserPickerProps> = ({
  value,
  users,
  onChange,
  editable,
  label,
  ...rest
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <InlineEditable
        {...rest}
        editable={editable && users.length > 0}
        kind="select"
        open={!!anchor}
        onOpen={setAnchor}
      />
      <Menu
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        onClick={(event) => event.stopPropagation()}
        slotProps={{ paper: { sx: { maxHeight: 360 } } }}
      >
        {label && <ListSubheader>{label}</ListSubheader>}
        {users.map((user) => (
          <MenuItem
            key={user.id}
            selected={user.id === value}
            onClick={() => {
              setAnchor(null);
              if (user.id !== value) onChange(user.id);
            }}
          >
            <Typography variant="body2">{user.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default InlineUserPicker;
